import { render, staticRenderFns } from "./countriesList.vue?vue&type=template&id=5c189d70"
import script from "./countriesList.vue?vue&type=script&lang=js"
export * from "./countriesList.vue?vue&type=script&lang=js"
import style0 from "./countriesList.vue?vue&type=style&index=0&id=5c189d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports